"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSchemaDefinitions = buildSchemaDefinitions;
exports.makeFlatSchemaKey = makeFlatSchemaKey;
exports.makeFlatSchemaRef = makeFlatSchemaRef;
exports.mapObjectDeep = mapObjectDeep;
var _keyBy = _interopRequireDefault(require("lodash/keyBy"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function mapObjectDeep(object, mapValue) {
  if (typeof object !== "object") {
    return object;
  }
  if (Array.isArray(object)) {
    return object.map(innerValue => mapValue(innerValue) || mapObjectDeep(innerValue, mapValue));
  }
  const entries = Object.entries(object).map(_ref => {
    let [key, value] = _ref;
    const res = mapValue(value);
    return [key, res === undefined ? mapObjectDeep(value, mapValue) : res];
  });
  return Object.fromEntries(entries);
}
function makeFlatSchemaKey(schemaId) {
  return schemaId.replace(/[^a-zA-Z-]/g, ":");
}
function makeFlatSchemaRef(schemaId) {
  return {
    $ref: "#/definitions/".concat(makeFlatSchemaKey(schemaId))
  };
}
function buildSchemaDefinitions(originalSchemas) {
  const schemas = originalSchemas.map(schema => {
    return mapObjectDeep(schema, value => {
      if (typeof value === "object" && value.$id) {
        return makeFlatSchemaRef(value.$id);
      }
      if (typeof value === "object" && value.$ref) {
        // assume value.$ref is a $id
        return makeFlatSchemaRef(value.$ref);
      }
    });
  });
  return (0, _keyBy.default)(schemas, _ref2 => {
    let {
      $id
    } = _ref2;
    return makeFlatSchemaKey($id);
  });
}